import { render, staticRenderFns } from "./GroupTeamAdd.vue?vue&type=template&id=08109406&scoped=true"
import script from "./GroupTeamAdd.vue?vue&type=script&lang=js"
export * from "./GroupTeamAdd.vue?vue&type=script&lang=js"
import style0 from "./GroupTeamAdd.vue?vue&type=style&index=0&id=08109406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08109406",
  null
  
)

export default component.exports